/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react'
import { Typography, withStyles } from '@material-ui/core'
import styles from './styles'
import { patchTeamsMemberAction } from 'src/reducers/teams/action'
import { messageBoxHideAction } from 'src/reducers/message-box/action'
import { PatchContent, PatchData } from 'src/model/patch'
import {
  CoreButton,
  CoreTextField,
  CoreFormLayout,
  CoreAutoComplete,
} from 'src/components/core'
import { useSelector } from 'react-redux'
import { paymentStatus } from 'src/model/payment-status'
const EditMember = props => {
  const { entity, dispatch, classes } = props
  const collectionSettings = useSelector(
    state => state.collection.collectionSettings,
  )

  const [memberPaymentStatus, setMemberPaymentStatus] = React.useState(
    paymentStatus.find(s => s.id === entity.paymentStatus) || null,
  )
  const [memberName, setMemberName] = React.useState(entity.name)
  const [memberEmail, setMemberEmail] = React.useState(entity.email)

  const handlePatchMember = () => {
    const patchSource = new PatchData(null, entity.id)
    patchSource.addContent(
      new PatchContent(memberName, 'name', PatchData.OPERATION_REPLACE),
    )

    patchSource.addContent(
      new PatchContent(memberEmail, 'email', PatchData.OPERATION_REPLACE),
    )

    if (collectionSettings.accessRule === 4 && memberPaymentStatus) {
      patchSource.addContent(
        new PatchContent(
          memberPaymentStatus.id,
          'paymentStatus',
          PatchData.OPERATION_REPLACE,
        ),
      )
    }

    const teamsId = collectionSettings.teams.find(x => x.default === true).id
    dispatch(
      patchTeamsMemberAction(teamsId, entity.id, patchSource, () => {
        dispatch(messageBoxHideAction())
      }),
    )
  }

  const handleCloseModal = () => {
    dispatch(messageBoxHideAction())
  }
  return (
    <div className={classes.modal}>
      <div className={classes.modalContent}>
        <CoreFormLayout
          flexDirection="row"
          justifyContent="space-between"
          alignItems="center"
          width="100%"
          itemGap="8px"
          itemsPerRow={collectionSettings.accessRule === 4 ? 3 : 2}
        >
          <CoreTextField
            value={memberName}
            onChange={e => setMemberName(e.target.value)}
            label="Name"
            fullWidth
          />
          <CoreTextField
            value={memberEmail}
            onChange={e => setMemberEmail(e.target.value)}
            label="Email"
            fullWidth
          />
          {collectionSettings.accessRule === 4 && (
            <CoreAutoComplete
              value={memberPaymentStatus}
              onChange={(e, newValue) => setMemberPaymentStatus(newValue)}
              label="Payment Status"
              fullWidth
              options={paymentStatus}
              freeSolo={false}
              disableClearable
            />
          )}
        </CoreFormLayout>

        <div className={classes.modalContent__buttons}>
          <CoreButton
            variant="text"
            size="small"
            color="secondary"
            onClick={() => handleCloseModal()}
          >
            Cancel
          </CoreButton>
          <CoreButton
            variant="contained"
            size="small"
            color="success"
            onClick={() => handlePatchMember()}
          >
            Save Changes
          </CoreButton>
        </div>
      </div>
    </div>
  )
}
export default withStyles(styles)(EditMember)
